import { PaddedSection } from '../../../components/Section';
import { StaticDataItem } from '../../../../../api/useAccountApi';
import {
  useAccountContext,
} from '../../../../../contexts';
import { EmploymentHistory } from '../../../../../contexts/account/IncomeAndEmployment';
import PositionSectionEmploymentType from './PositionSectionEmploymentType';
import PositionSectionWorkingStatus from './PositionSectionWorkingStatus';
import PositionSectionAddress from './PositionSectionAddress';
import { ineSubSectionHeaderCss } from './IncomeAndEmploymentSection';

export default function PositionSection({
  employmentHistory,
  applicantIndex,
  countries,
  industries,
  jobTitles,
  employmentHistoryIndex,
}: {
  employmentHistory: EmploymentHistory,
  applicantIndex: number,
  countries: StaticDataItem[],
  industries: StaticDataItem[],
  jobTitles: StaticDataItem[],
  employmentHistoryIndex: number,
}) {
  const { account } = useAccountContext();
  const { errors, warnings } = account;

  const field = `applicants[${applicantIndex}].incomeAndEmployment.employmentHistory[${employmentHistoryIndex}]`;

  return (
    <PaddedSection
      id={employmentHistory?.id}
      title="Position"
      level={2}
      errors={errors}
      warnings={warnings}
      headerCss={ineSubSectionHeaderCss}
      titleIcon={<></>}
    >
      <PositionSectionEmploymentType
        employmentHistory={employmentHistory}
        industries={industries}
        jobTitles={jobTitles}
        field={field}
      />
      <PositionSectionWorkingStatus
        employmentHistory={employmentHistory}
        field={field}
      />
      <PositionSectionAddress
        employmentHistory={employmentHistory}
        countries={countries}
        field={field}
      />
    </PaddedSection>
  );
}
